<template>
  <div class="app-wrapper">
    <div
      class="app-wrapper-left"
      :style="{ width: collapsed ? '5rem' : '13rem' }"
    >
      <div class="logo">
        <img v-if="!collapsed" src="@/assets/layout/logo.png" alt />
        <img v-else src="@/assets/layout/logos.png" alt />
      </div>
      <a-menu
        :selected-keys="selectedKey"
        :open-keys.sync="openKey"
        mode="inline"
        theme="dark"
        :inline-collapsed="collapsed"
      >
        <template v-for="e in routesList">
          <template>
            <a-menu-item
              v-if="e.meta.showPage"
              @click="handlerClickMenu(e.path)"
              :key="e.path"
            >
              <a-icon :type="e.meta.icon" />
              <span>{{ e.meta.title }}</span>
            </a-menu-item>
          </template>
        </template>
      </a-menu>
    </div>
    <div
      class="main-container"
      :style="{
        width: collapsed ? 'calc(100vw - 5rem)' : 'calc(100vw - 13rem)',
      }"
    >
      <div class="sidebar-container">
        <div class="sidebar-left">
          <div class="collased" @click="changeCollased">
            <img src="@/assets/layout/shrink.png" alt />
          </div>

          <h2>江苏检察机关先进典型宣传展示平台</h2>

          <div class="navbj">
            <div
              class="label"
              :class="$route.path.indexOf(e.path) != -1 ? 'active' : ''"
              @click="handlerFirstClickMenu(e)"
              v-for="(e, i) in routes"
              :key="i"
            >
              <a-icon :type="e.meta.icon" />
              <p>{{ e.meta.title }}</p>
            </div>
          </div>

          <div class="snavbj">
            <div
              class="label"
              :class="$route.path.indexOf(e.path) != -1 ? 'active' : ''"
              @click="handlerFirstClickMenu(e)"
              v-for="(e, i) in routes"
              :key="i"
            >
              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>{{ e.meta.title }}</span>
                </template>
                <a-icon :type="e.meta.icon" />
              </a-tooltip>
            </div>
          </div>
        </div>
        <div class="sidebar-right">
          <div class="siderightbj">
            <!-- <a-icon type="bell" />
                        <a-icon type="search" /> -->
            <!-- <img src="@/assets/layout/bell.png" alt />
            <img src="@/assets/layout/search.png" alt /> -->
            <a-dropdown>
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                <!-- <img class="avatar"  alt /> -->
                <p>
                  {{ userInfo.jcy_name }}检察院 {{ userInfo.username }}
                  <a-icon type="caret-down" />
                </p>
              </a>
              <a-menu slot="overlay" @click="onClick">
                <a-menu-item key="1">
                  <a href="javascript:;"><a-icon type="wechat" /> 解绑微信</a>
                </a-menu-item>
                <a-menu-item key="2">
                  <a href="javascript:;"><a-icon type="logout" /> 退出登录</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <!-- <div class="person">
                            <img src="@/assets/layout/person.png" alt />
                            <p>用户名</p>
                        </div> -->
          </div>
        </div>
      </div>
      <div class="main-container-content">
        <div class="container-content">
          <transition name="fade-transform" mode="out-in">
            <router-view v-if="$route.meta.keepAlive" />
            <keep-alive v-else>
              <router-view />
            </keep-alive>
          </transition>
        </div>
      </div>
    </div>

    <!-- 更改配色 -->
    <!-- <changeTheme></changeTheme> -->
  </div>
</template>

<script>
import store from "@/store";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import changeTheme from "./components/changeTheme.vue";
import { wxunbind } from "@/api/open";
export default {
  name: "Layout",
  components: {
    changeTheme,
  },
  data() {
    return {
      collapsed: false,
      routes: [], //一级栏目
      routesList: [], //二级栏目
      matched: "",
      avatar: store.getters.avatar,
      selectedKey: "", //选中栏目
      openKey: "", //展开栏目
    };
  },
  computed: { ...mapGetters(["userInfo", "roles"]) },
  watch: {
    $route: {
      handler: function (val) {
        this.getKey();
        this.getFirstRouterName();
        this.getSecondRouterName();
        if (val.path == "/taggingManage/look-advanced") {
          this.selectedKey = ["advanced"];
        }
      },
      immediate: true,
    },
    selectedKey(val) {
      if (val[0] == "look-advanced") {
        this.selectedKey = ["advanced"];
      }
    },
  },
  methods: {
    ...mapActions(["GetInfo"]),
    //获取一级栏目
    getFirstRouterName() {
      this.routes = this.$router.options.routes;
      this.routes = this.routes.filter((item) => item.meta.isFirst);
    },
    //获取二级栏目
    getSecondRouterName() {
      let routes = this.$router.options.routes;
      this.matched = routes.filter(
        (item) => this.$route.path.indexOf(item.path) == 0
      );
      
      if(this.userInfo.jcy1==this.userInfo.jcy_id) {
        this.routesList = this.roles;
      }
      else {
        this.routesList = this.roles;
        this.routesList.splice(6,7)
        console.log(this.routesList);
      }
      console.log(this.routesList);
    },
    //获取选中key和展开key
    getKey() {
      switch (this.$route.path.split("/").length) {
        case 5:
          this.selectedKey = [
            this.$route.path.split("/").slice(-3)[0] +
              "/" +
              this.$route.path.split("/").slice(-2)[0],
          ];
          this.openKey = [this.$route.path.split("/").slice(-3)[0]];
          break;
        case 4:
          this.selectedKey = [
            this.$route.path.split("/").slice(-2)[0] +
              "/" +
              this.$route.path.split("/").pop(),
          ];
          this.openKey = [this.$route.path.split("/").slice(-2)[0]];
          break;
        case 3:
          this.selectedKey = [this.$route.path.split("/").pop()];
          this.openKey = [];
          break;
        case 2:
          this.selectedKey = [this.$route.path.split("/").pop()];
          this.openKey = [];
          break;

        default:
          this.selectedKey = [];
          this.openKey = [];
          break;
      }
    },
    //一级栏目点击
    handlerFirstClickMenu(item) {
      this.$router
        .push({
          path:
            item.path +
            "/" +
            item.children[0].path +
            `${
              item.children[0].children.length > 0
                ? "/" + item.children[0].children[0].path
                : ""
            }`,
        })
        .catch((e) => {});
    },
    //二级栏目点击
    handlerClickMenu(path1, path2) {
      sessionStorage.removeItem("jcy_name")
      this.$router
        .push({
          path:
            this.matched[0].path + "/" + path1 + `${path2 ? "/" + path2 : ""}`,
        })
        .catch((e) => {});
    },

    //收缩
    changeCollased() {
      this.collapsed = !this.collapsed;
    },

    onClick({ key }) {
      if (key == 1) {
        let self = this;
        self.$confirm({
          title: `确定解绑 (${self.userInfo.nickname})微信吗？`,
          okText: "确定",
          cancelText: "取消",
          // content: (h) => <div style="color:red;">Some descriptions</div>,
          onOk() {
            let parmas = {
              user_id: self.userInfo.id,
            };
            wxunbind(parmas)
              .then((res) => {
                if (res.code == 200) {
                  store.dispatch("LogOut").then(() => {
                    // 调用解绑微信接口
                    // console.log("解绑微信成功");
                    sessionStorage.clear();
                    location.href = "/login";
                  });
                } else {
                  alert(2222);
                  self.$message.error("操作异常");
                }
              })
              .catch((error) => {
                self.$message.error("操作异常");
              });
          },
          onCancel() {
            // console.log("Cancel");
          },
        });
      } else if (key == 2) {
        this.$confirm({
          title: "确定注销并退出系统吗？",
          okText: "确定",
          cancelText: "取消",
          // content: (h) => <div style="color:red;">Some descriptions</div>,
          onOk() {
            store.dispatch("LogOut").then(() => {
              sessionStorage.clear();
              location.href = "/login";
              // this.$router
              //   .push({
              //     path: "/",
              //   })
              //   .catch((e) => {});
            });
          },
          onCancel() {
            // console.log("Cancel");
          },
        });
      }
    },
  },
  created() {
    // this.GetInfo();
    // this.getList();
    console.log(this.userInfo);
  },
  activated() {
    // this.getList();
  }, //如果页面有keep-alive缓存功能，这个函数会触
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
<style lang="scss" scoped>
.ant-menu-submenu {
  .ant-menu-sub {
    background: $left-second-level-bj-color;
    .ant-menu-item-selected {
      background: $choose-color;
    }
    .ant-menu-item {
      color: $font-color;
    }
  }
}
.avatar {
  width: 24px;
  height: 24px;
  object-fit: fill;
  border-radius: 50%;
}
</style>
